import { render } from "./tableSimples.vue?vue&type=template&id=8db144ce&scoped=true"
import script from "./tableSimples.vue?vue&type=script&lang=js"
export * from "./tableSimples.vue?vue&type=script&lang=js"

import "./tableSimples.vue?vue&type=style&index=0&id=8db144ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db144ce"]])

export default __exports__